import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { CLEAR_EDITOR_COMMAND } from 'lexical'
import { Send } from 'lucide-react'
import { Button } from '@/components/ui/button'
import * as React from 'react'

export default function ActionsPlugin({ handleActionClick }: { handleActionClick: () => void }): React.JSX.Element {
  const [editor] = useLexicalComposerContext()

  return (
    <div className='absolute text-right m-2 bottom-0 right-0 z-10'>
      <Button
        size="sm"
        className="gap-2"
        onClick={() => {
          handleActionClick()
          editor.dispatchCommand(CLEAR_EDITOR_COMMAND, undefined)
          editor.focus()
        }}
      >
        <span>Send</span>
        <Send className="h-4 w-4" />
      </Button>
    </div>
  )
}
